import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import DspProductListAccordian from '../../atoms/DpsProductListAccordian';
import styles from './dpslistItem.module.scss';

function DpsListItem({ content, index, reportingDataOnClickEvent }) {
    const { name, pickedForYouContent, productId } = content;

    return (
        <div className={styles['dpsproduct-content-wrapper']}>
            <div className={styles['dpsproduct-itemcontainer']}>
                <div
                    className={
                        styles['dpsproduct-itemcontainer-title']
                    }
                >
                    {ReactHtmlParser(`${name}`)}
                </div>
                <div
                    className={
                        styles['dpsproduct-itemcontainer-subtitle']
                    }
                >
                    Picked for you because:
                </div>
                <div
                    className={
                        styles['dpsproduct-itemcontainer-description']
                    }
                >
                    <h3 className="pickedForYou-description">
                        {pickedForYouContent}
                    </h3>
                </div>
                <div
                    className={
                        styles['dpsproduct-itemcontainer-accordian']
                    }
                >
                    <DspProductListAccordian
                        productId={productId}
                        id={index}
                        context={content}
                        reportingDataOnClickEvent={
                            reportingDataOnClickEvent
                        }
                    />
                </div>
            </div>
        </div>
    );
}

export default DpsListItem;
